export enum StaticDataSource {
  fastenerType = 'fastenerType',
  materialGrade = 'materialGrade',
  headStyle = 'headStyle',
  driveRecessStyle = 'driveRecessStyle',
  threadSize = 'threadSize',
  surfaceFinish = 'surfaceFinish',
  threadPitch = 'threadPitch',
  postFinish = 'postFinish',
  osps = 'osps',
  sems = 'sems',
  unitOfMeasure = 'unitOfMeasure',
}

export enum UnitOfMeasure {
  EA = 'EA',
  CWT = 'CWT',
  LBS = 'LBS',
  M = 'M',
}
